import React, { useContext, useEffect, useRef }from 'react';

import { 
  useWindowDimensions,
  useDirectTransCheck,
  useIECheck,
  MoveCheckStop,
  postHeightToParent,
} from 'utils';

import PresentPC from 'components/pages/Thanks/PresentPC';
import PresentSP from 'components/pages/Thanks/PresentSP';
import { LP_URL } from 'utils/constant';

import AppContext from 'fluxes/context';
import { CHANGE_MODIFY_MODE, REGISTER } from 'fluxes/actions';

const Thanks = ()=>{
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;
  const pageEl = useRef(null);

  const { state, dispatch } = useContext(AppContext);
  useDirectTransCheck({ state });
  console.log('Thanks', { state });

  MoveCheckStop();

  // クリア
  useEffect(() => {
    dispatch({
      type: CHANGE_MODIFY_MODE,
      isModify: false,
    });
    dispatch({ type: REGISTER });
  }, [ dispatch ]);
  
  // LP埋め込み時の高さ送信
  useEffect(() => {
    if(state.lpMode){
      postHeightToParent(state.lpOrigin, pageEl.current.clientHeight);
    }
  }, [ state.lpMode, state.lpOrigin, pageEl ]);

  const onClickMainButton = {
    next: () => {
      window.location.href = LP_URL;
    },
  };
  return(
    <div id='pageThanks' ref={pageEl}>
      { isSp ? (
        <PresentSP
          onClickMainButton={onClickMainButton}
          lpMode={state.lpMode}
        />
      ) : (
        <PresentPC
          onClickMainButton={onClickMainButton}
          lpMode={state.lpMode}
        />
      )}
    </div>
  );
};

export default Thanks;